import axios from 'axios';
import * as _ from 'lodash';

import {
    IPermission,
    IPermissionOption
} from '../models';

export default {
    // 获取权限配置项
    getPermissions(): Promise<IPermission[]> {
        return axios.get<IPermission[]>('/api/permission-options').then(res => {
            return res.data;
        });
    },

    // 获取用户的权限
    getUserPermissionOptions(userId: string): Promise<IPermissionOption[]> {
        return axios.get<IPermissionOption[]>(`/api/users/${userId}/current/permissions`).then(res => {
            return res.data;
        });
    },

    // 获取当前用户的权限
    getCurrentPermissionOptions(): Promise<IPermissionOption[]> {
        return axios.get<IPermissionOption[]>('/api/users/current/permissions').then(res => {
            return res.data;
        });
    },

    // 获取当前用户的某项权限
    // (在权限配置中，找到相应的权限项，查看当前用户的权限项得值)
    getCurrentCertainPermissionOptionValue(permissionOptionName: string): Promise<boolean> {
        return Promise.all([
            this.getPermissions(),
            this.getCurrentPermissionOptions()
        ]).then(results => {
            const permissions: IPermission[] = results[0];
            const currentPermissionOptions: IPermissionOption[] = results[1];
            let kind: number;
            let certainPermissionOption: IPermissionOption;
            _.forEach(permissions, permission => {
                certainPermissionOption = _.find(permission.options, { name: permissionOptionName });
                if (certainPermissionOption) {
                    kind = permission.kind;
                    return false;
                }
            });
            if (kind) {
                const currentCertainPermissionOption: IPermissionOption = _.find(currentPermissionOptions, { kind });
                return (currentCertainPermissionOption.value & certainPermissionOption.value) === certainPermissionOption.value;
            }
            return false;
        });
    }
}